import React from 'react';
import getIncludedResource from '../../../../../../helpers/getIncludedResource';
import { get, startCase } from 'lodash';
import PremiumBreakdown from '../../../../../product/components/PremiumBreakdown';
import MatchPremiumButton from '../../../MatchPremiumButton/MatchPremiumButton';
import { Button } from '../../../../../../common/components';
import IssueButtonPolicy from '../../../../../product/components/IssueButton/IssueButtonPolicy';
import { Alert, Col, Row } from 'react-bootstrap';

const getTopPremiums = (premiums, isB2C) => {
  const sortedPremiums =
    premiums && Array.isArray(premiums)
      ? premiums.sort((a, b) => {
          let premiumA = 1000000;
          let premiumB = 1000000;

          if (a && a.attributes && a.attributes.gross > 0) {
            premiumA = a.attributes.gross;
          }

          if (b && b.attributes && b.attributes.gross > 0) {
            premiumB = b.attributes.gross;
          }

          return premiumA - premiumB;
        })
      : premiums;

  if (isB2C) {
    return sortedPremiums ? sortedPremiums.slice(0, 4) : [];
  }
  return sortedPremiums;
};

const showPayButton = (premium, isBroker) => {
  if (
    isBroker &&
    !!premium.attributes.issued_at &&
    !!premium.attributes.outstanding_by_element
  ) {
    const outstandingGross = !!premium.attributes.outstanding_by_element.find(
      (outstanding) => {
        return outstanding.type === 'gross' && outstanding.amount !== 0;
      },
    );
    if (outstandingGross) {
      return true;
    }
  }
  return false;
};

const showIssueButton = (errors, declines, isSanctionComplete,isSanctionPassed) => {
  if (errors?.length) {
    return false;

  }
  if (declines?.length) {
    return false;
  }
  return !isSanctionComplete || (isSanctionComplete && !!isSanctionPassed);


};

const formatTransactionSource = (premium) => {
  const transactionSource = get(premium, 'attributes.transaction_source', '') || '';

  if (transactionSource === 'payment gateway') {
    return 'Card';
  }

  return startCase(transactionSource);
};

const Premium = ({
  premium,
  resource,
  brokerId,
  isSanctionComplete,
  isSanctionPassed,
  product,
  declarationText,
  showButtons,
}) => {
  if (!premium.attributes) {
    return null;
  }

  const scheme = getIncludedResource(premium, resource.included, 'scheme');

  return (
    <Row className="row quoted-scheme">
      <Col sm={2} className="scheme-logo-container">
        <img
          alt={'insurer logo'}
          className="img-responsive insurer-logo"
          src={scheme.data.attributes.logo}
        />
      </Col>
      <Col sm={2} className="text-center">
        <span className="cover-level">{scheme.data.attributes.cover_level}</span>
      </Col>
      <Col sm={2} className="text-center">
        <span className="scheme-type">{scheme.data.attributes.scheme_type}</span>
      </Col>
      {!showButtons && <Col sm={3}>&nbsp;</Col>}
      <Col sm={3} className="text-center">
        <div className={'policy-details-premium'}>
          <div className={'policy-details-premium-details'}>
            <PremiumBreakdown
              premium={premium.attributes}
              savedPremium={premium.attributes}
              id={premium.id}
              block
              showIpt={false}
            />
            <span className="small">{get(premium.attributes, 'premium_type')}</span>
            <span className="small">{formatTransactionSource(premium)}</span>
          </div>
          <div>
            {showPayButton(premium, !!brokerId) && (
              <MatchPremiumButton
                brokerId={brokerId}
                premiumId={premium.id}
                policyId={resource.data.id}
              />
            )}
          </div>
        </div>
      </Col>
      {showButtons && (
        <Col sm={3}>
          <div className={'quote-buttons'}>
            {premium.attributes.quote_document && (
              <a
                href={premium.attributes.quote_document}
                target="_blank"
                className="pull-left"
              >
                <Button size="xs" label="Quotation" />
              </a>
            )}
            { showIssueButton(premium.attributes.errors, premium.attributes.declines, isSanctionComplete, isSanctionPassed)  && (
              <IssueButtonPolicy
                bsStyle="primary"
                isSanctionPassed={isSanctionPassed}
                isSanctionComplete={isSanctionComplete}
                className="pull-left"
                application={resource}
                schemeId={premium.attributes.scheme.id}
                coverLevel={premium.attributes.scheme.cover_level}
                product={product}
                definitions={product?.data?.attributes?.metadata?.definitions}
                purchaseDeclaration={
                  product?.data?.attributes?.metadata?.purchase_declaration
                }
                productCode={product?.data?.attributes?.product_code ?? ''}
                declaration={declarationText}
                isMta={resource?.data?.attributes?.quote_type === 'mid term adjustment'}
                premiumHasGoldUpgrade={
                  premium?.attributes?.information?.upgrade &&
                  premium?.attributes?.information?.upgrade?.amount.difference !== 0
                }
                upgradeScheme={premium?.attributes?.information?.upgrade?.scheme}
                options={premium?.attributes?.information?.available_options}
              />
            )}
          </div>
        </Col>
      )}
    </Row>
  );
};

const Premiums = ({
  isPolicy,
  premiums,
  isB2C,
  product,
  declarationText,
  showButtons,
  resource,
  showBackDateCover,
  brokerId,
}) => {
  const topPremiums = isPolicy ? premiums : getTopPremiums(premiums, isB2C);
  return (
    <>
      <Row>
        <Col xs={12}>
          <h3>Premiums</h3>
        </Col>
        <Col xs={12}>
          <Col xs={12}>
            {topPremiums.map((premium, i) => {
              return (
                <Premium
                  brokerId={brokerId}
                  premium={premium}
                  resource={resource}
                  key={i}
                  isB2C={isB2C}
                  showButtons={showButtons}
                  isSanctionComplete={
                    resource?.data?.attributes?.metadata?.sanctions_check_complete
                  }
                  isSanctionPassed={
                    resource?.data?.attributes?.metadata?.sanctions_result
                  }
                  product={product}
                  declarationText={declarationText}
                />
              );
            })}
          </Col>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {showBackDateCover ? (
            <Alert bsStyle="danger">
              Cannot issue cover - travel date in the past, please re-quote using the edit
              function.
            </Alert>
          ) : null}
        </Col>
      </Row>
    </>
  );
};

export default Premiums;
